module.exports = __webpack_public_path__ + "static/logo-3e4d4b7b78ab7cacac34b3d056262c36.svg";